import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { onRedirectingTilInnlogging } from '../../User/UserProvider';

// Vises i det korte vinduet mellom «silent renew feilet» og at nettleseren
// faktisk navigerer til OneLogin. Portal + inline-styling for å overstyre
// evt. monitor-mode-CSS som gjør bakgrunnen svart.
export const SesjonRedirectOverlay = (): JSX.Element | null => {
  const [synlig, setSynlig] = useState(false);

  useEffect(() => {
    return onRedirectingTilInnlogging(() => setSynlig(true));
  }, []);

  if (!synlig) return null;

  return ReactDOM.createPortal(
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2147483647,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        color: '#000',
      }}
    >
      <div
        style={{
          maxWidth: '400px',
          padding: '24px 32px',
          borderRadius: '8px',
          border: '1px solid #ccc',
          backgroundColor: '#fff',
          textAlign: 'center',
          fontSize: '18px',
          lineHeight: 1.4,
        }}
      >
        Sesjonen din har utløpt. Sender deg til innlogging…
      </div>
    </div>,
    document.body
  );
};

export default SesjonRedirectOverlay;
